define('mustache-language/dictionary',['require','exports','module','./lib/languages','./lib/language-hash','./lib/locale'],function(require,exports,module){
    var languages = require( "./lib/languages" ),
        languageHash = require( "./lib/language-hash" ),
        localeParse = require( "./lib/locale" );

    function get(langCode){
        var lang = languages[langCode];

        return lang ? {
            code        : langCode,
            dictionary  : lang,
            hash        : languageHash[langCode]
        } : null;
    }

    function set(langCode, dictionary){
        var locale  = localeParse(langCode),
            current = get(locale.full) || {
                code        : locale.full,
                dictionary  : {},
                hash        : {}
            };

        languages[locale.full]      = extend(current.dictionary, dictionary);
        languageHash[locale.full]   = extend(current.hash, buildLangHash(current.dictionary));

        return current;
    }

    function extend(target, source){
        var key;
        for(key in source){
            target[key] = source[key];
        }
        return target;
    }

    function buildLangHash(dictionary){
        var key,
            map={};

        for(key in dictionary){
            map[key.toLowerCase()] = key;
        }
        return map;
    }

    return {
        get : function(langCode){
            if(!langCode){
                return languages;
            }
            var locale = localeParse(langCode);
                
            return get(locale.full) || get(locale.primary) || set(locale.full)
        },

        set : function(langCode, dictionary){
            return set(langCode, dictionary);
        }
    }
}); 

